/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  // Product description see more toggle
  function initDescriptionToggle() {
    const toggleButtons = document.querySelectorAll(
      '[data-description-toggle]'
    );

    for (const button of toggleButtons) {
      button.addEventListener('click', function () {
        const container = this.closest('[data-description-truncate]');
        if (!container) return;

        container.classList.toggle('is-expanded');
      });
    }
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDescriptionToggle);
  } else {
    initDescriptionToggle();
  }

  // Re-initialize on Shopify section load (for theme editor)
  document.addEventListener('shopify:section:load', initDescriptionToggle);

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
